export default {
  simplePlaceSearch: {
    noPlaceFound: 'Nenalezeno žádné místo s přidaným obsahem',
    openSidebarToSeeRouteDetails: 'Otevřete postranní panel a zobrazte podrobnosti o trase',
    unknownSearchPlaceError: 'Chyba neznámého místa hledání'
  }
}
